import React from 'react';
import Land from './images/land.svg';
import styles from './MoveInReady.module.css';

const MoveInReady = () => {
  return (
    <div className={styles.moveInSection}>
      <Land viewBox="0 0 48 48" />
      <h3 className={styles.heading}>Move-In Ready</h3>
      <p className={styles.intro}>
        Move-in ready homes are already placed on land and are available for
        purchase.
      </p>
    </div>
  );
};

export default MoveInReady;
